module.exports = __webpack_public_path__ + "img/qinzi.0999d8e4.png";